module.exports = __webpack_public_path__ + "img/zhuanhua.6282a5c2.svg";